import React from "react";

import { Header, Grid, SemanticICONS } from "semantic-ui-react";

import TableApp, { ITableAppRender, IPagination } from "../../components/TableApp";
import Search, { ISearch } from "../../components/Search";
import { IFields } from "../Search/FilterBuilder";
import TemplateMain from "../TemplateMain";

interface ITemplateTableProps {
    loading?: boolean;
    content?: JSX.Element;
    title: string;
    icon: SemanticICONS;
    insert?: JSX.Element;
    predefinedFilters?: JSX.Element;
    tableLoading: boolean;
    tableRender: ITableAppRender[];
    tableList: any[];
    tableActions?: (data: any, index: number) => JSX.Element[] | undefined;
    tablePagination?: IPagination;
    tableOnChangeRecords?: (value: number) => void;
    searchPlaceHolder: string;
    onSearch: ({ searchString, type }: ISearch) => void;
    filterType?: "simples" | "avancado";
    filterFields?: IFields[];
}

export default function TemplateTable(props: ITemplateTableProps) {
    const content = (
        <Grid columns="equal">
            <Grid.Row>
                <Grid.Column>
                    <Header size="huge" content={props.title} icon={props.icon} />
                </Grid.Column>
                {props.insert &&
                    <Grid.Column textAlign="right">
                        {props.insert}
                    </Grid.Column>
                }
            </Grid.Row>
            {props.predefinedFilters &&
                <Grid.Row>
                    <Grid.Column>
                        {props.predefinedFilters}
                    </Grid.Column>
                </Grid.Row>
            }
            {props.content &&
                <Grid.Row>
                    <Grid.Column>
                        {props.content}
                    </Grid.Column>
                </Grid.Row>
            }
            <Grid.Row>
                <Grid.Column>
                    <Search
                        placeholder={props.searchPlaceHolder}
                        onSearch={props.onSearch}
                        filterFields={props.filterFields}
                        filterType={props.filterType}
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Column>
                <Grid.Row>
                    <TableApp
                        render={props.tableRender}
                        list={props.tableList}
                        actions={props.tableActions}
                        pagination={props.tablePagination}
                        onChangeRecords={props.tableOnChangeRecords}
                        loading={props.tableLoading}
                    />
                </Grid.Row>
            </Grid.Column>
        </Grid>
    );

    return (
        <TemplateMain
            loading={props.loading || false}
            content={content}
        />
    );
}
